module.exports = __webpack_public_path__ + "static/media/Baayen_A_Dynamic_Approach_To_Lexical_Processing_taipe_1128.f48b41c0.pdf";